import { useEffect, useState } from "react";
import db from "./Firebase";
import { collection, getDocs } from "firebase/firestore/lite";
import ReadMoreReact from "read-more-react";

const Post = () => {
  const [post, setPost] = useState([]);
  const [id, setId] = useState(1);
  useEffect(async () => {
    const colref = collection(db, "blogpost");
    await getDocs(colref).then(async (snapshot) => {
      let posts = [];
      await snapshot.docs.forEach((doc) => {
        posts.push({ ...doc.data(), id: doc.id });
      });
      setPost(posts);
    });
  }, []);

  return (
    <div className="post">
      <p className="header">BLOG</p>
      {post != null ? (
        <div className="posts-container">
          {post.map((doc) => {
            // console.log(doc);
            const time = doc.timestamp.toDate();
            const date = time.getDate();
            const month = time.toLocaleString("default", { month: "long" });
            return (
              <div key={doc.id} className="post-container">
                <p className="title">{doc.Title}</p>
                <img
                  className="image"
                  alt=""
                  src={`https://picsum.photos/id/${
                    doc.Content.length + 23
                  }/650/490`}
                />
                <ReadMoreReact
                  text={doc.Content}
                  min={80}
                  ideal={100}
                  max={200}
                  readMoreText={"Read more"}
                />
                <p className="author">
                  {date} {month} | By {doc.Name}
                </p>
              </div>
            );
          })}
        </div>
      ) : null}
      <div className="footer">
        Developed by{" "}
        <a href="https://github.com/Praveen-webdev" className="anchor">
          {" "}
          Praveen
        </a>
      </div>
    </div>
  );
};
export default Post;
